export default {
  'search_text': 'Search',
  'tab_common': 'Common',
  'tab_popular': 'Key Country',
  'title_overall': 'Overall',
  'title_region': 'Region',
  'title_market': ' Market',
  'title_popular': 'Key',
  'title_country': ' Country',
  'select_all': 'Select All',
  'clear_all': 'Clear All',
  'no_data': 'No result found',
  'global': 'All',
  'global_except_china': 'Global except China mainland',
  'global_no_data_text': 'Including comments from game store and social media.',
  'unidentified_no_data_text': 'Including all comments by keywords monitoring and part by accounts monitoring in social media which can not be distinguished from markets.',
  'global_message': 'Global includes reviews fromgame store and social media, which cannot be distinguished from regions/market.'
}